/* TODO fix these by using a link styled button */
/* eslint-disable jsx-a11y/anchor-is-valid */ 
/* eslint-disable-next-line no-script-url */ 

import React from 'react';
import '../../../styles/globals.css'
import { Box, Link } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

function DashboardBackButtonComponent(props) {

    const karmaContext = useKarmaPoolContext();

    const linkToUse = props.urlSuffix !== undefined ? "/karma/dashboard/" + props.urlSuffix : "/karma/dashboard";

    return (
        <Box sx={{ marginBottom: "3rem"}}>
            <p className={karmaStyles.homepageDescription}>
                <Link href={linkToUse}>
                back
                </Link>
            </p>
        </Box>
    );
}

export default DashboardBackButtonComponent;
